import { render, staticRenderFns } from "./TableBudgetSimple.vue?vue&type=template&id=6129527a&scoped=true"
import script from "./TableBudgetSimple.vue?vue&type=script&lang=js"
export * from "./TableBudgetSimple.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetSimple.vue?vue&type=style&index=0&id=6129527a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129527a",
  null
  
)

export default component.exports